import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SplashComponent} from './splash/splash.component';
import { LoginComponent } from './login/login.component';
import { MapaComponent } from './mapa/mapa.component';
import { CareerComponent } from './career/career.component';
import { NavbarComponent } from './navbar/navbar.component';
import { DatosComponent } from './datos/datos.component';
import { EscannerComponent } from './escanner/escanner.component';

const routes: Routes = [
  { path: 'splash', component: SplashComponent },
  { path: 'mapa', component: MapaComponent },
  { path: 'login', component: LoginComponent },
  { path: 'career', component: CareerComponent },
  { path: 'workshop/:id', component: NavbarComponent },
  { path: 'mis-datos', component: DatosComponent },
  { path: 'escanner', component: EscannerComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
